var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3558 10.1759L8.55409 4.54991C8.19207 4.19886 7.5 4.41165 7.5 4.87402L7.5 16.126C7.5 16.5883 8.19207 16.8011 8.55409 16.4501L14.3558 10.8241C14.5481 10.6376 14.5481 10.3624 14.3558 10.1759Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldArrowRight);
export default __webpack_public_path__ + "static/media/bold_arrow_right.7816f70e2543bb6a53bf547d2e25c95f.svg";
export { ForwardRef as ReactComponent };